import { WtButton } from "../Button/button";
import styles from"./callTransferFailed.module.scss"
import { useSelector } from "react-redux";
import userImg from "../../../styles/images/Failed-Empty State.svg";
import { CallPopUpAgentActions } from "../../../store/slices/voice_call_slice/call_popup_agent";
import { useDispatcher } from "../../../custom_hooks/use_app_dispatch";
import { dispositionSliceActions } from "../../../store/slices/dispositionSlice/postDisposition";
import { useEffect } from "react";

function CallTransferFailed() {
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  const dispatch = useDispatcher();
  
  useEffect(() => {
    if (popUpDetails?.isCallTransferFailed) {
      const timer = setTimeout(() => {
        dispatch(CallPopUpAgentActions.CallTransferingpopup(false));
    }, 4000);
      return () => clearTimeout(timer);
    }
  }, [popUpDetails?.isCallTransferFailed]);


  return (
    <>
      {popUpDetails?.isCallTransferFailed && (
        <div className={`w3-animate-top ${styles.callcontainartopsec}`}>
          <div className={`${styles.callwhisperinnercon} ${styles.calltransscussesswidges}`}>
            <div className={styles.succesconsec}>
              <label>
                <img src={userImg} alt="" className={styles.userImage} />
              </label>
              <span>Call transfer Failed</span>
           
            </div>
          </div>
        </div>
      )}
      {/*     
      {opendialPadDetails.isTransferPopupOpen&& <div className={`w3-animate-top ${styles.callcontainartopsec}`}>
        <div className={styles.transferingCall}>
          <img src={transferingImg} alt="" />
          <p className={styles.transferingTitle}>Transferring call</p>
          <p className={styles.loadingIcon}><Lottie style={{ "width": 50, "margin": "0 auto" }}
            animationData={groovyWalkAnimation} /></p>
        </div>
      </div>} */}
    </>
  );
}
export default CallTransferFailed;
